import React, { useEffect, useState } from "react";
import "./My_Profile.css";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import { Button } from "react-bootstrap";

import { Link, useLocation, useNavigate } from "react-router-dom";
import Personal_Info from "./personal_info/Personal_Info";

import { useDispatch, useSelector } from "react-redux";
import {
  getNotifications,
  NotificationStatus,
} from "../../features/notifications/notificationSlice";
import { formatDate } from "../../utils/common";
import { myAccount } from "../../features/my_account/Slice";
import OrderCard from "./common_components/order_card/OrderCard";
import Blue_Btn from "../common_components/common_btn/Blue_Btn/Blue_Btn";
import Logout_Offcanvas from "./logout_offcanvas/Logout_Offcanvas";
import Saved_Address from "./saved_address/Saved_Address";

const My_Profile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState("first"); // default tab
  const dispatch = useDispatch();
  useEffect(() => {
    if (location.state?.selectedTab) {
      setActiveKey(location.state.selectedTab);
    }
  }, [location.state]);

  const notifications = useSelector(
    (state) => state.notification.notifications,
  );

  const user = useSelector((state) => state.myaccount.addMyaccount);

  useEffect(() => {
    // if (user?.id) {
    dispatch(getNotifications());
    // }
  }, []);

  const handleSeen = async (id) => {
    const res = await dispatch(NotificationStatus(id));
    // console.log(res, "handleSeen");
  };

  const isSignIn = useSelector((state) => state.auth.is_signin);

  // useEffect(() => {
  //   dispatch(myAccount());
  // }, []);

  const [showLogoutModal, setshowLogoutModal] = useState(false);

  return (
    <section className="My_Orders My_Profile">
      <div className="container">
        <div className="top_title_div">
          <p className="title_text">MY ACCOUNT</p>

          <div className="btn_holder">
            <Blue_Btn btnText={"LOG OUT"} onClick={() => {setshowLogoutModal(true)}}/>
          </div>
        </div>

        <div className="action_tab_section">
          <Tab.Container
            id="left-tabs-example"
            activeKey={activeKey}
            onSelect={(k) => setActiveKey(k)}
          >
            <div className="row">
              <div className="col-lg-3 col-md-4">
                <Nav variant="pills" className="">
                  <Nav.Item>
                    <Nav.Link eventKey="first">
                      <div className="img_holder">
                        <img
                          className="tab_icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/my_order/img1.png"
                          }
                        />
                      </div>

                      <span className="tab_text">Personal Information</span>
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link eventKey="second" as={Link} to="/my-orders">
                      <div className="img_holder">
                        <img
                          className="tab_icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/my_order/img2.png"
                          }
                        />
                      </div>
                      <span className="tab_text">My Orders</span>
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link eventKey="third">
                      <div className="img_holder">
                        <img
                          className="tab_icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/my_order/img3.png"
                          }
                        />
                      </div>
                      <span className="tab_text">Saved Address</span>
                    </Nav.Link>
                  </Nav.Item>

                  {/* <Nav.Item>
                    <Nav.Link eventKey="third">
                      <div className="img_holder">
                        <img
                          className="tab_icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/my_order/bell.png"
                          }
                        />
                      </div>
                      <span className="tab_text">Notifications</span>
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link eventKey="fourth" as={Link} to="/my-wallet">
                      <div className="img_holder">
                        <img
                          className="tab_icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/my_order/wallet.png"
                          }
                        />
                      </div>
                      <span className="tab_text">My Wallet</span>
                    </Nav.Link>
                  </Nav.Item> */}
                </Nav>
              </div>

              <div className="col-lg-9 col-md-8">
                <div className="">
                  <Tab.Content>
                    <Tab.Pane eventKey="first">
                      <Personal_Info />
                    </Tab.Pane>

                    <Tab.Pane eventKey="second">
                      <div
                        className=""
                        onClick={() => {
                          navigate("/delivered-order");
                        }}
                      >
                        <OrderCard
                          title="ScanMart Grocery"
                          footer_text_color="#1f7041"
                          img="/assets/images/profile/myaccount/img1.png"
                          orderId="Order ID #675843"
                          items="2 Items"
                          kwd="Rs.: 200"
                          footer_text="Delivering in 10 mins"
                          date="27th Oct. | 03:28 pm"
                        />
                        <OrderCard
                          title="ScanMart Grocery"
                          footer_text_color="#1f7041"
                          img="/assets/images/profile/myaccount/img1.png"
                          orderId="Order ID #675843"
                          items="2 Items"
                          kwd="Rs.: 200"
                          footer_text="Delivering in 10 mins"
                          date="27th Oct. | 03:28 pm"
                        />
                      </div>
                    </Tab.Pane>

                    <Tab.Pane eventKey="third">
                          <Saved_Address/>
                    </Tab.Pane>
                     </Tab.Content>
                </div>
              </div>
            </div>
          </Tab.Container>
        </div>
      </div>

      <Logout_Offcanvas show={showLogoutModal} onHide={() => setshowLogoutModal(false)} />
    </section>
  );
};

export default My_Profile;
